/**
 * Permission-tree definitions for vessel portal modules (served by frontend-vessel).
 * Kept in the office app so admins can still grant vessel_* permissions.
 */
export type VesselSidebarModuleDef = {
  pathSegment: string;
  listLabel: string;
  permissionModuleKey: string;
  newLink?: { label: string; pathSuffix: string };
};

export const VESSEL_SIDEBAR_MODULES: VesselSidebarModuleDef[] = [
  {
    pathSegment: 'dashboard',
    listLabel: 'Vessel Dashboard',
    permissionModuleKey: 'vessel_dashboard',
  },
  {
    pathSegment: 'requisitions',
    listLabel: 'Supply Requisition',
    permissionModuleKey: 'vessel_supply_requisitions',
    newLink: { label: 'New requisition', pathSuffix: '/new' },
  },
  {
    pathSegment: 'pending-deliveries',
    listLabel: 'Pending deliveries',
    permissionModuleKey: 'vessel_pending_deliveries',
  },
  {
    pathSegment: 'crew',
    listLabel: 'Crew list',
    permissionModuleKey: 'vessel_crew',
  },
  {
    pathSegment: 'wrh',
    listLabel: 'Working Rest Hours',
    permissionModuleKey: 'vessel_wrh',
    newLink: { label: 'Open day', pathSuffix: '/new' },
  },
];
